/** The mount path the app is served from (Vite `base`), without a trailing slash. */
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/$/, '');
export const LOGIN_PATH = `${BASE_PATH}/login`;
export const ADMIN_LOGIN_PATH = `${BASE_PATH}/admin/login`;
